module.exports = __webpack_public_path__ + "img/99.4c94f605.jpg";